import { createAsyncThunk } from '@reduxjs/toolkit'
import { IUserFrontend } from '../../../entity/User'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { getUrlWithVersion } from '../../../api/api'

export const deleteUser = createAsyncThunk<
    { login: string },
    { user: IUserFrontend },
    ThunkConfig<string>
>('userSlice/deleteUser', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { user } = args

    try {
        await api.delete(getUrlWithVersion(`/users/${user.login}`))
        throwSuccessMessage(`Success! ${user.login} deleted!`)

        return { login: user.login }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to delete user')
    }
})
